import { render, staticRenderFns } from "./descuentos.vue?vue&type=template&id=65a41c87&scoped=true&"
import script from "./descuentos.vue?vue&type=script&lang=js&"
export * from "./descuentos.vue?vue&type=script&lang=js&"
import style0 from "./descuentos.vue?vue&type=style&index=0&id=65a41c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a41c87",
  null
  
)

export default component.exports